import { NgModule } from '@angular/core';

import { IntellimixApiService } from '../api';

import { SysApiIntellimixApiService } from './sys-api-intellimix-api.service';

@NgModule({
	providers: [
		SysApiIntellimixApiService,
		{
			provide: IntellimixApiService,
			useClass: SysApiIntellimixApiService
		}
	]
})
export class SysApiIntellimixDataAccessModule {}
